import { FC } from 'react';

import ButtonMighty from '@components/elements/ButtonMighty';

import './SuccessModal.css';

type Props = {
  title?: string | JSX.Element;
  action?: string;
  visible?: boolean;
  onSubmit?: () => void;
  onCancel?: () => void;
};
const SuccessVoteModal: FC<Props> = ({
  title = (
    <>
      Your vote <br />
      has been <br />
      submitted <br />
    </>
  ),
  action = 'Explore MegaX World',
  visible,
  onCancel,
  onSubmit,
}) => {
  return (
    <>
      <div
        className="overlay"
        onClick={onCancel}
        style={visible ? { opacity: 0.7, display: 'block' } : { opacity: 0 }}
      />
      <div
        className="vote-success-modal"
        style={visible ? { opacity: 1, display: 'flex' } : { opacity: 0 }}
      >
        {title && <h1 className="text-3xl">{title}</h1>}
        <div>
          <ButtonMighty
            onClick={onSubmit}
            color="#FFFF00"
            borderColor="#FF46FF"
            textColor="#FF46FF"
            text={action}
            margin="0"
          />
        </div>
      </div>
    </>
  );
};

export default SuccessVoteModal;
